import React, {
  FC,
  Suspense,
  useEffect,
  useLayoutEffect,
  useRef,
  useState
} from 'react'
import { ConfigProvider as AntConfigProvider, ButtonProps } from 'antd'
import Loading from './components/base/loading'
import en_US from 'antd/locale/en_US'
import { Locale } from 'antd/es/locale'
import { FormListContext, ProConfigProvider } from '@ant-design/pro-components'

export type ConfigProviderProps = {
  locale: string
  children: React.ReactNode
  theme?: Object
}
const theme = {}

export const I18N = {
  'en-US': import('antd/locale/en_US'),
  'zh-CN': import('antd/locale/zh_CN')
}

const ConfigProvider: FC<ConfigProviderProps> = (
  props: ConfigProviderProps
) => {
  const { locale = 'en_US' } = props
  const localeRef = useRef<Locale>()
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const getLocale = async (locale: string) => {
    setIsLoading(true)
    try {
      const data = (localeRef.current = await I18N[locale]).then(
        res => res.default
      )
    } catch (error) {
      localeRef.current = en_US
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getLocale(locale)
  }, [locale])
  if (isLoading) return <Loading></Loading>
  return (
    <AntConfigProvider
      theme={{
        token: {
          colorPrimary: '#44C9C1',
          borderRadius: 6
        },
        cssVar: { key: 'botlab' }
      }}
      wave={{
        disabled: true
      }}
      {...(localeRef.current ? { locale: localeRef.current } : {})}
    >
      <FormListContext.Provider
        value={{
          creatorButtonProps: {
            type: 'default'
          } as ButtonProps
        }}
      >
        {props.children}
      </FormListContext.Provider>
    </AntConfigProvider>
  )
}

const ConfigProviderWrapper: FC<ConfigProviderProps> = (
  props: ConfigProviderProps
) => {
  return <ConfigProvider {...props}></ConfigProvider>
}

export default ConfigProviderWrapper
